import { Person } from "../../../../types/types";
import { MonthReport } from "./MonthReport";

export const ReportTab = ({person}:{person:Person}) => {
  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background">
      <MonthReport person={person}/>
    </div>
  )
};
